import React from 'react';
import { Download, Printer, Receipt, FileText, X } from 'lucide-react';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription, DialogClose } from '@/components/ui/dialog';
import { Button } from '@/components/ui/button';
import { API } from './useFamilyFinance';
import { TitleStatus, TitleValues, canViewBoleto } from './FinanceTitleCard';
import { fmtBRL, fmtDate, yearLabel } from './organization';

export const boletoUrl = (title, token) => {
  if (!title.pdf_url) return null;
  const url = new URL(title.pdf_url, API);
  url.searchParams.set('token', token);
  return url.toString();
};
const DocumentActions = ({ title: t, token }) => {
  const openBoleto = print => {
    const win = window.open(boletoUrl(t, token), '_blank');
    if (win && print) setTimeout(() => { try { win.print(); } catch (_) { /* impressão disponível pelo PDF */ } }, 700);
  };
  return <div className="flex flex-wrap gap-2">
    {canViewBoleto(t) && <>
      <Button size="sm" variant="outline" onClick={() => openBoleto(false)} data-testid="finance-details-download"><Download className="w-4 h-4 mr-2" />Baixar PDF</Button>
      <Button size="sm" variant="outline" onClick={() => openBoleto(true)} data-testid="finance-details-print"><Printer className="w-4 h-4 mr-2" />Imprimir</Button>
    </>}
    {t.status === 'pago' && t.comprovante_url && <Button size="sm" variant="outline" onClick={() => window.open(t.comprovante_url, '_blank', 'noopener,noreferrer')} data-testid="finance-details-receipt"><Receipt className="w-4 h-4 mr-2" />Ver comprovante</Button>}
    {t.nota_fiscal?.pdf_url && <Button size="sm" variant="outline" onClick={() => window.open(t.nota_fiscal.pdf_url, '_blank', 'noopener,noreferrer')} data-testid="finance-details-nfse"><FileText className="w-4 h-4 mr-2" />Ver NFS-e</Button>}
  </div>;
};

export const FinanceDialogs = ({ modal, onClose, token }) => {
  if (!modal) return null;
  const { title: t, type } = modal;
  return <Dialog open onOpenChange={open => !open && onClose()}>
    <DialogContent className={`w-[calc(100%-2rem)] max-h-[90dvh] overflow-y-auto [&>button:last-child]:hidden ${type === 'boleto' ? 'max-w-4xl h-[85dvh] flex flex-col' : 'max-w-xl'}`} data-testid={`finance-${type}-modal`}>
      <DialogClose asChild><button type="button" className="absolute right-3 top-3 p-1 rounded hover:bg-slate-100" data-testid="finance-modal-close" aria-label="Fechar"><X className="h-5 w-5" /></button></DialogClose>
      <DialogHeader className="pr-7 text-left">
        <DialogTitle className="text-base break-words" data-testid="finance-modal-title">{type === 'boleto' ? 'Boleto' : 'Detalhes do título'}{t.view.installment ? ` · Parcela ${t.view.installment}` : ''}</DialogTitle>
        <DialogDescription className="break-words" data-testid="finance-modal-context">{t.view.studentName} · {yearLabel(t.view.year)}</DialogDescription>
      </DialogHeader>
      {type === 'boleto' ? <iframe src={boletoUrl(t, token)} title="Boleto" className="min-h-0 flex-1 w-full border-0" data-testid="boleto-iframe" /> : <div className="space-y-5">
        <TitleStatus title={t} prefix="details" />
        <p className="text-sm break-words" data-testid="finance-details-description">{t.descricao || t.categoria || 'Título financeiro'}</p>
        <TitleValues title={t} prefix="details" />
        <dl className="grid grid-cols-2 gap-4 text-sm">
          {[
            ['competence', 'Competência', t.competencia], ['bank', 'Banco', t.banco],
            ['bank-number', 'Nosso número', t.nosso_numero], ['discount-until', 'Desconto até', t.desconto_ate && fmtDate(t.desconto_ate)],
            ['paid-date', 'Pago em', t.status === 'pago' && fmtDate(t.data_pagamento)],
            ['paid-value', 'Valor pago', ['pago', 'parcial'].includes(t.status) && fmtBRL(t.valor_pago)],
            ['fine', 'Multa', t.multa > 0 && fmtBRL(t.multa)], ['interest', 'Juros', t.juros > 0 && fmtBRL(t.juros)],
          ].filter(([, , value]) => value !== null && value !== undefined && value !== false && value !== '').map(([id, label, value]) => <div key={id} className="min-w-0"><dt className="text-xs text-slate-500">{label}</dt><dd className="mt-1 break-words" data-testid={`finance-details-${id}`}>{value}</dd></div>)}
        </dl>
        <DocumentActions title={t} token={token} />
      </div>}
    </DialogContent>
  </Dialog>;
};